import { ThemeProvider } from '@material-ui/core';
import { createTheme } from "@material-ui/core/styles";
import axios from "axios";
import MaterialTable from "material-table";
import { Component } from "react";
import { Button, Card, Form, Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import { FaCheckCircle, FaFileAlt, FaHourglassHalf, FaPencilAlt } from "react-icons/fa";
import LogoPath from '../images/logo-min.png';
import ConfirmModal from "../utils/ConfirmModal";
import { downloadCSV } from "../utils/csvDownload";
import DeliveryOrderPDF from "../utils/DeliveryOrderPDF";
import { hasPermission } from "../utils/usePermission";
import CommonLoader from "./loaderComponent/CommonLoader";
import CommonToast from "./Toaster/CommonToast";
export default class DeliveryChallanList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      deliveryChallans: [],
      deliveryChallanPrint: [],
      poItems: [],
      dcNumber: "",
      dcDate: "",
      customerId: "",
      projectId: "",
      purchaseOrderId: "",
      status: "pending",
      loading: true,
      showToast: false,
      toastMessage: "",
      toastVariant: "",
      showConfirm: false,
      deleteId: null,
      showModal: false,
      selectedDelivery: null,
      newStatus: "",
      color: ''
    };
  }

  openConfirmModal = () => {
    this.setState({ showConfirm: true, });
  };
  closeConfirmModal = () => {
    this.setState({ showConfirm: false });
  };

  componentDidMount() {
    this.fetchDeliveryChallans();
  }

  fetchDeliveryChallans = () => {
    this.setState({ loading: true });
    axios
      .get("/deliveryChallans")
      .then((res) => {
        this.setState({ deliveryChallans: res.data, loading: false });
      })
      .catch((error) => {
        this.setState({
          loading: false,
          showToast: true,
          toastMessage: error.response?.data?.message || "Error fetching delivery challans",
          toastVariant: "danger",
          color: 'red'
        });
      });
  };

  handleDelete = () => {

    axios
      .delete(`/deliveryChallans/${this.state.deleteId}`)
      .then(() => {
        this.setState({
          showToast: true,
          toastMessage: "Delivery Challan deleted successfully",
          toastVariant: "success",
          color: 'green',
          deleteId: null,
          showConfirm: false,
        });
        this.fetchDeliveryChallans();
      })
      .catch((error) => {
        this.setState({
          showToast: true,
          toastMessage: error.response?.data?.message || "Error deleting delivery challan",
          toastVariant: "danger",
          color: 'red',
          deleteId: null,
          showConfirm: false,
        });
      });
  };

  handleMoveAdd = () => {
    this.props.history.push('/DeliveryChallan-add')
  }

  handleEdit = (rowData) => {
    console.log("rowData", rowData);
    const { id } = rowData;
    this.props.history.push(`/DeliveryChallan-edit/${id}`, { data: rowData });
  };

  handleView = (rowData) => {
    console.log("rowData", rowData);
    const { id } = rowData;
    this.props.history.push(`/DeliveryChallan-view/${id}`, { data: rowData });
  };

  fetchDeliveryChallan = (id) => {
    return axios
      .get(`/deliveryChallans/view/${id}`)
      .then((res) => {
        const dc = res.data;
        console.log("dc.items", dc.items);
        this.setState({
          dcNumber: dc.dcNumber,
          dcDate: dc.dcDate,
          customerId: dc.customerId,
          projectId: dc.projectId,
          purchaseOrderId: dc.purchaseOrderId,
          status: dc.status,
          poItems: dc.items.map((item) => ({
            purchaseOrderItemId: item.purchaseOrderItemId,
            itemName: item.purchaseOrderItem?.item?.name,
            askedQuantity: item.purchaseOrderItem.quantity,
            serialNumber: item.purchaseOrderItem.serialNumber,
            pendingQuantity: item.purchaseOrderItem.pendingQuantity,
            uom: item.uom,
            quantity: item.quantity,
          })),
        }, () => {
          setTimeout(() => {
            this.setState({ loading: false });
          }, 900);
        });

        return dc;
      })
      .catch((err) => {
        console.error("Error fetching delivery challan:", err);
        this.setState({
          showToast: true,
          toastMessage: "Failed to load delivery challan data",
          toastVariant: "danger",
          color: 'red'
        });
        setTimeout(() => {
          this.setState({ loading: false });
        }, 900);
        return null; // in case of error
      });
  };

  fetchDeliveryChallanprint = async (id) => {
    this.setState({ loading: true });

    try {
      const res = await axios.get(`/deliveryChallans/view/${id}`);
      this.setState({ deliveryChallanPrint: res.data, loading: false, completed: true });
    } catch (error) {

    }
  }

  handlePrint = async (rowData) => {

    const companyInfo = {
      name: "SNAP SOLUTIONS & PROJECT INDIA PRIVATE LIMITED",
      registered_Office: `209-A 'TARA SADAN', Shri Krishna Avenue, Khandwa Road, Limbodi, Indore, (M.P.) 452001`,
      email: "projects@snapsolutions.in",
      phone: "+91 75090 78787",
      Website: "www.snapsolutions.in",
      PAN: 'AABCG0949C',
      CIN_No: "U43900MP2023PTC065127",
      terms: [
        "1. Payment due within 30 days",
        "2. Warranty as per manufacturer"
      ],
      footerText: "Terms and conditions apply"
    };

    try {
      await this.fetchDeliveryChallanprint(rowData.id);
      // Convert image to base64
      const response = await fetch(LogoPath);
      const blob = await response.blob();
      const logoBase64 = await new Promise((resolve) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.readAsDataURL(blob);
      });
      if (this.state.completed && this.state.deliveryChallanPrint) {
        await DeliveryOrderPDF.generate(this.state.deliveryChallanPrint, logoBase64, companyInfo);
      }
    } catch (error) {
      console.error('Failed to generate PDF:', error);
      alert('Failed to generate PDF. Please check console for details.');
    }
  };


  handlePrintAll = () => {
    // debugger;
    const { deliveryChallans } = this.state
    console.log("first", deliveryChallans)
    if (deliveryChallans) {
      downloadCSV(deliveryChallans, "Challans_Info");
    }
  }
  handleStatusChange = (data) => {
    this.setState({ showModal: true, selectedDelivery: data, newStatus: data.status });
  };


  handleStatusUpdate = () => {

    const { selectedDelivery, newStatus } = this.state;
    console.log(selectedDelivery, newStatus);

    if (!newStatus) {
      this.setState({
        showToast: true, toastMessage: "Please select a status!", toastVariant: "danger",
        color: 'red'
      });
      return;
    }
    const payload = {
      customerId: selectedDelivery.customerId,
      projectId: selectedDelivery.projectId,
      purchaseOrderId: selectedDelivery.purchaseOrderId,
      dcNumber: selectedDelivery.dcNumber,
      dcDate: selectedDelivery.dcDate,
      status: newStatus,
      items: selectedDelivery.items,
    }
    axios.put(`deliveryChallans/${selectedDelivery.id}`, payload, {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    }).then(() => {
      this.setState({ showToast: true, toastMessage: "Status updated successfully!", toastVariant: "success", color: 'green', showModal: false });
      this.fetchDeliveryChallans();
    }).catch(() => {
      this.setState({ showToast: true, toastMessage: "Failed to update status!", toastVariant: "danger", color: 'red' });
    });
  };


  render() {
    const { deliveryChallans, loading, showToast, toastMessage, toastVariant } = this.state;
    const theme = createTheme({
      overrides: {
        MuiTableCell: {
          root: {
            padding: '6px 6px 6px 6px'
          }
        }
      }
    })
    return (
      <>
        <CommonToast
          show={showToast}
          onClose={() => this.setState({ showToast: false })}
          message={toastMessage}
          variant={toastVariant}
          color={this.state.color}
        />
        <ConfirmModal
          show={this.state.showConfirm}
          onHide={() => this.setState({ showConfirm: false, deleteId: null })}
          onConfirm={() => this.handleDelete()}
          title="Delete Confirmation"
          message="Are you sure you want to delete this Delivery Challan?"
        />
        <CommonLoader isLoading={loading}>
          <div className="container-fluid pt-4">
            <div className='d-flex search-btn-gap challan-print'>
              {
                hasPermission('M19B1') && (
                  <div className='add-role'>
                    <Button variant="primary" className="d-flex align-items-center gap-2 px-4 py-2 rounded-pill shadow-sm custom-add-button" onClick={this.handleMoveAdd}> <i className="fa fa-plus-circle"></i> Add Delivery Challan</Button>
                  </div>
                )
              }
              <div className="print-button">
                {
                  hasPermission('M19B7') && (
                    <Button variant="outline-primary" onClick={this.handlePrintAll} ><i className="fa fa-print"></i></Button>
                  )}
              </div>
            </div>
            <div className="col-sm-12">
              <Card>
                <Card.Header style={{ backgroundColor: "#515e73", color: "white" }}>
                  <div className="panel-title">
                    <strong>Delivery Challan List</strong>
                  </div>
                </Card.Header>
                <Card.Body>
                  <ThemeProvider theme={theme}>
                    <MaterialTable
                      title="Delivery Challans List"
                      columns={[
                        {
                          title: "ID", field: "id", editable: "never",
                          cellStyle: { minWidth: 100 },
                          headerStyle: { minWidth: 100 }
                        },
                        {
                          title: "DC Number", field: "dcNumber",
                          cellStyle: { minWidth: 150 },
                          headerStyle: { minWidth: 150 }
                        },
                        {
                          title: "DC Date",
                          field: "dcDate",
                          type: "date",
                          render: rowData => {
                            if (!rowData.dcDate) return '';
                            const date = new Date(rowData.dcDate);
                            return `${date.getDate().toString().padStart(2, '0')}/${(date.getMonth() + 1)
                              .toString()
                              .padStart(2, '0')}/${date.getFullYear()}`;
                          },
                          cellStyle: { minWidth: 120 },
                          headerStyle: { minWidth: 120 }
                        },
                        // {
                        //   title: "DC Date", field: "dcDate", type: "date"
                        //   , cellStyle: { minWidth: 120 },
                        //   headerStyle: { minWidth: 120 }
                        // },
                        {
                          title: "Customer", field: "customer.name",
                          cellStyle: { minWidth: 250 },
                          headerStyle: { minWidth: 250 }
                        },
                        {
                          title: "Project", field: "project.name",
                          cellStyle: { minWidth: 300 },
                          headerStyle: { minWidth: 300 }
                        },
                        {
                          title: "PO No.", field: "purchaseOrder.poNumber",
                          cellStyle: { minWidth: 150 },
                          headerStyle: { minWidth: 150 }
                        },

                        {
                          title: "Status",
                          field: "status",
                          render: rowData => {
                            const status = rowData?.status;
                            const baseStyle = {
                              display: 'inline-flex',
                              alignItems: 'center',
                              gap: '6px',
                              fontSize: '0.875rem',
                              padding: '4px 12px',
                              borderRadius: '20px',
                              fontWeight: 500
                            };

                            if (status === 'Paid') {
                              return (
                                <span style={{
                                  ...baseStyle,
                                  backgroundColor: '#d1e7dd',
                                  color: '#0f5132',
                                  border: '1px solid #badbcc'
                                }}>
                                  <FaCheckCircle /> Paid
                                </span>
                              );
                            } else if (status === 'Pending') {
                              return (
                                <span style={{
                                  ...baseStyle,
                                  backgroundColor: '#fff3cd',
                                  color: '#664d03',
                                  border: '1px solid #ffe69c'
                                }}>
                                  <FaHourglassHalf /> Pending
                                </span>
                              );
                            } else if (status === 'Invoice') {
                              return (
                                <span style={{
                                  ...baseStyle,
                                  backgroundColor: '#cfe2ff',
                                  color: '#084298',
                                  border: '1px solid #b6d4fe'
                                }}>
                                  <FaFileAlt /> Invoice
                                </span>
                              );
                            } else {
                              return (
                                <span style={{
                                  ...baseStyle,
                                  backgroundColor: '#f8d7da',
                                  color: '#842029',
                                  border: '1px solid #f5c2c7'
                                }}>
                                  <FaPencilAlt /> Draft
                                </span>
                              );
                            }
                          }
                        },
                        {
                          title: "Total Item Value ", field: "status",
                          cellStyle: { minWidth: 120 },
                          headerStyle: { minWidth: 120 },
                          render: rowData => {

                            const totalValue = (rowData.items || []).reduce((sum, item) => {
                              return sum + (parseFloat(item.purchaseOrderItem?.totalValue) || 0);
                            }, 0);

                            return `₹ ${totalValue.toFixed(2)}`;
                          }
                        },

                        {
                          title: 'Action',
                          render: rowData => (
                            <>
                              {
                                rowData.status === 'Draft' &&

                                hasPermission('M19B2') && (
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip id={`tooltip-edit-${rowData.id}`}>Edit Delivery Challan</Tooltip>}
                                  >
                                    <Button size="sm" variant="outline-info" className="mr-2  info"
                                      onClick={() => this.handleEdit(rowData)}
                                    >
                                      <i className="fa fa-edit"></i>
                                    </Button>
                                  </OverlayTrigger>
                                )}


                              {
                                //rowData.status != 'Paid' &&
                                hasPermission('M19B4') && (
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip id={`tooltip-print-${rowData.id}`}>Print Delivery Challan</Tooltip>}
                                  >
                                    <Button size="sm" variant="outline-info" className="mr-2 info"
                                      onClick={() => this.handlePrint(rowData)}
                                    >
                                      <i className="fa fa-print"></i>
                                    </Button>
                                  </OverlayTrigger>
                                )
                              }
                              {
                                (rowData.status === 'Pending' || rowData.status === 'Invoice') &&
                                hasPermission('M19B5') && (
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip id={`tooltip-status-${rowData.id}`}>Change Status</Tooltip>}
                                  >
                                    <Button size="sm" variant="outline-info" className="mr-2 info"
                                      onClick={() => this.handleStatusChange(rowData)}
                                    >
                                      <i className="fas fa-sync-alt"></i>
                                    </Button>
                                  </OverlayTrigger>
                                )
                              }
                              {
                                // rowData.status === 'draft' &&
                                hasPermission('M19B6') && (
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip id={`tooltip-vie-${rowData.id}`}>View Delivery Challan</Tooltip>}
                                  >
                                    <Button size="sm" variant="outline-info" className="mr-2 info"
                                      onClick={() => this.handleView(rowData)}
                                    >
                                      <i className="fa fa-eye"></i>
                                    </Button>
                                  </OverlayTrigger>
                                )
                              }
                              {hasPermission('M19B3') && (
                                <OverlayTrigger
                                  placement="top"
                                  overlay={<Tooltip id={`tooltip-delete-${rowData.id}`}>Delete Delivery Challan</Tooltip>}
                                >
                                  <Button size="sm" variant="outline-danger" className="mr-2 delete-btn"
                                    onClick={() => this.setState({ showConfirm: true, deleteId: rowData.id })}
                                  // onClick={() => this.handleDelete(rowData.id)}
                                  >
                                    <i className="fas fa-trash"></i>
                                  </Button>
                                </OverlayTrigger>
                              )}
                            </>
                          ),
                          cellStyle: { width: '220px', minWidth: '220px', textAlign: 'center' }, // Adjust width as needed
                          headerStyle: { width: '220px', minWidth: '220px', textAlign: 'center' }
                        }
                      ]}
                      data={deliveryChallans}
                      actions={[
                        // {
                        //   icon: "add",
                        //   tooltip: "Add Delivery Challan",
                        //   isFreeAction: true,
                        //   onClick: () => this.props.history.push("/deliveryChallan-add"),
                        // },
                        // {
                        //   icon: "edit",
                        //   tooltip: "Edit Delivery Challan",
                        //   onClick: (event, rowData) => this.props.history.push(`/deliveryChallan-edit/${rowData.id}`),
                        //   disabled: (rowData) => rowData.status === "invoiced" || rowData.status === "paid",
                        // },
                        // {
                        //   icon: "delete",
                        //   tooltip: "Delete Delivery Challan",
                        //   onClick: (event, rowData) => this.handleDelete(rowData.id),
                        // },
                      ]}
                      options={{
                        pageSize: 10,
                        pageSizeOptions: [10, 20, 30, 50, 75, 100],
                        rowStyle: (rowData, index) => {
                          if (index % 2) {
                            return { backgroundColor: '#f2f2f2' }
                          }
                        },
                        actionsColumnIndex: -1,
                        search: true,
                        paging: true,
                      }}
                    />
                  </ThemeProvider>
                </Card.Body>
              </Card>
            </div>
          </div>
          <Modal show={this.state.showModal} onHide={() => this.setState({ showModal: false })}>
            <Modal.Header closeButton>
              <Modal.Title>Update Status</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form>
                <Form.Group>
                  <Form.Label className="required">Select Status</Form.Label>
                  <Form.Control
                    as="select"
                    className="form-select"
                    value={this.state.newStatus}
                    onChange={(e) => this.setState({ newStatus: e.target.value })}
                  >
                    <option value="">Select</option>
                    <option value="Invoice">Invoiced</option>
                    <option value="Paid">Paid</option>
                  </Form.Control>
                </Form.Group>
              </Form>
            </Modal.Body>
            <Modal.Footer>
              <Button variant='primary' className="d-flex align-items-center gap-2 px-4 py-2 rounded-pill shadow-sm custom-add-button btn btn-primary" onClick={this.handleStatusUpdate} size="sm">
                Update
              </Button>
              <Button variant='danger' className="d-flex align-items-center gap-2 px-4 py-2 rounded-pill shadow-sm custom-add-button-cancel" onClick={() => this.setState({ showModal: false })} size="sm">
                Cancel
              </Button>
            </Modal.Footer>
          </Modal>
        </CommonLoader>
      </>
    );
  }
}
